const EXPIRED_WEBSOCKET_TIME_IN_DAYS = 3; // if you chage this numbers, you should update test
const DAY_IN_MILISECONDS = 86400000;

const EXPIRED_TIME = EXPIRED_WEBSOCKET_TIME_IN_DAYS * DAY_IN_MILISECONDS;


export const checkWebSocketTimeoutExpired = (creationDate, currentDate) => {
    const differenceTime = currentDate - creationDate;

    return !(differenceTime <= EXPIRED_TIME);

};



// WEBPACK FOOTER //
// ./src/containers/websockets/utils/utils.js